/**
 * The one plain-language statement about how search works, reused
 * everywhere the site talks about AI / data handling (Corporate-Safe
 * page, FAQ, privacy policy) so those pages can never drift apart.
 *
 * What is actually true, so any change here stays honest (the assistant can
 * also ask a clarifying question or answer a question about the tools, using
 * only the tool descriptions and FAQ entries sent along with the query):
 *  - The AI fallback (see ai-search/searchWithAI.ts) only runs for
 *    searches the plain search can't handle confidently.
 *  - It sends the typed search text plus a short list of candidate
 *    tool names/descriptions -- never a file -- to an AI language
 *    model, and falls back to plain results if that's unavailable
 *    (for example on a network that blocks AI services).
 *  - Every search is stored (search_log), with an anonymous device ID or
 *    the signed-in account, to improve search -- along with which result was
 *    clicked first, so we can tell whether search is actually helping.
 */
export const SEARCH_AI_NOTICE =
  "Only for complex or advanced searches, we use an AI language model to improve the results. Search entries, and which result you click, are stored to help us improve our search algorithm. Your files are never part of this.";
